// components/GoogleAnalytics.js
import React, { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { Helmet } from 'react-helmet';

const GoogleAnalytics = () => {
  const location = useLocation();

  useEffect(() => {
    const handleRouteChange = () => {
      if (typeof window.gtag !== 'undefined') {
        window.gtag('config', process.env.REACT_APP_GA_ID, {
          page_path: window.location.pathname,
        });
      } else {
        console.error('Google Analytics not loaded');
      }
    };

    handleRouteChange();
  }, [location]);

  return (
    <>
      <Helmet>
        <script async src={`https://www.googletagmanager.com/gtag/js?id=${process.env.REACT_APP_GA_ID}`}></script>
        <script>
          {`
            window.dataLayer = window.dataLayer || [];
            function gtag(){dataLayer.push(arguments);}
            gtag('js', new Date());
            gtag('config', '${process.env.REACT_APP_GA_ID}', {
              page_path: window.location.pathname,
            });
          `}
        </script>
      </Helmet>
    </>
  );
};

export default GoogleAnalytics;
